import { FC } from "react";
import {
  DIALOG_FOOTER_CTAS_DEFAULTS,
  DIALOG_FOOTER_CTAS_VARIANT_CLASS_MAP,
  DIALOG_FOOTER_CTA_VARIANT_BUTTON_WIDTH_MAP,
  TDialogFooterCtaProps,
} from "./Dialog.config";
import { Button } from "../../primitives";
import { cn } from "@/ui/lib";

export const DialogFooterCtas: FC<TDialogFooterCtaProps> = ({
  variant = DIALOG_FOOTER_CTAS_DEFAULTS.variant, ctas,
}) => {
  if (!ctas) { return null; }
  return (
    <div
      data-component="DialogFooterCtas"
      className={cn(
        "flex gap-2",
        DIALOG_FOOTER_CTAS_VARIANT_CLASS_MAP[variant],
      )}
    >
      { ctas.primary ? (
        <Button {...ctas.primary} width={DIALOG_FOOTER_CTA_VARIANT_BUTTON_WIDTH_MAP[variant]} />
      ) : null }
      { ctas.secondary ? (
        <Button {...ctas.secondary} variant="tertiary" width={DIALOG_FOOTER_CTA_VARIANT_BUTTON_WIDTH_MAP[variant]} />
      ) : null }
    </div>
  );
};
